<div class="team-area ptb-80 bg-f9f6f6">
  <div class="container">
    <div class="section-title">
      <span class="sub-title" i18n="@@servicesSubtitle">Services</span>
      <h3 i18n="@@servicesOfferedTitle">Offered Services</h3>
      <div class="bar"></div>
      <p i18n="@@servicesOfferedSubtitle">
        Every day more professionals join Wipperoz! These are some of the services that you can find in our platform
      </p>
    </div>
  </div>
  <div class="container-fluid p-0">
    <div class="team-slides">
      <owl-carousel-o [options]="teamSlides">
        <ng-template carouselSlide *ngFor="let item of categories">
          <div class="single-team">
            <div class="team-image">
              <a [routerLink]="'/servicing/' + item.slug">
                <img *ngIf="item.thumbnailImage === undefined" src="assets/img/team-image/1.jpg" alt="image" />
                <img *ngIf="item.thumbnailImage !== undefined" [src]="item.thumbnailImage" alt="image" />
              </a>
            </div>
            <div class="team-content">
              <div class="team-info">
                <a [routerLink]="'/servicing/' + item.slug"
                  ><h3>{{ item.categoryTitle }}</h3>
                  <span>{{ item.categorySubtitle }}</span></a
                >
              </div>

              <p>{{ item.contentDescription }}</p>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
</div>
